import { AvailableField } from '../ZohoEmployeeFieldsSetup/types';

export function getAvailableEmployeeTypesOnZoho(availableFields: AvailableField[]): string[] {
  const employeeTypeOptions =
    availableFields.find((field) => field.labelname === 'Employee_type')?.Options || [];

  return Object.values(employeeTypeOptions) as string[];
}
